import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxGroupComponent } from './checkbox-group.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [CheckboxGroupComponent],
  imports: [CommonModule, MatCheckboxModule],
  exports: [CheckboxGroupComponent],
})
export class CheckboxGroupModule {}
